import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  TeamOutlined,
  ShopOutlined,
  ApartmentOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  AppstoreOutlined,
  SwapOutlined,
  AccountBookOutlined,
  TruckOutlined,
  LinkOutlined,
  DollarOutlined,
  AuditOutlined,
  CloudUploadOutlined,
  BellOutlined,
  SettingOutlined,
} from '@ant-design/icons';

type MenuItem = Required<MenuProps>['items'][number];

/**
 * Primary navigation. Order matters — it sets the user's mental map.
 * See docs/ui-ux-design.md §2.2.
 */
const menuItems: MenuItem[] = [
  { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
  { key: 'users', icon: <TeamOutlined />, label: 'Users & Roles' },
  { key: 'superstores', icon: <ShopOutlined />, label: 'Superstores' },
  { key: 'hubs', icon: <ApartmentOutlined />, label: 'Child Hubs' },
  { key: 'service-areas', icon: <EnvironmentOutlined />, label: 'Service Areas & Routing' },
  { key: 'delivery-slots', icon: <ClockCircleOutlined />, label: 'Delivery Slots' },
  { key: 'catalogue', icon: <AppstoreOutlined />, label: 'Catalogue' },
  { key: 'uom', icon: <SwapOutlined />, label: 'UOM & Conversions' },
  { key: 'tax', icon: <AccountBookOutlined />, label: 'Tax Master' },
  { key: 'suppliers', icon: <TruckOutlined />, label: 'Suppliers' },
  { key: 'supplier-mappings', icon: <LinkOutlined />, label: 'Supplier Mappings' },
  { key: 'pricing', icon: <DollarOutlined />, label: 'Pricing' },
  { type: 'divider' },
  { key: 'approvals', icon: <AuditOutlined />, label: 'Approvals' },
  { key: 'bulk-jobs', icon: <CloudUploadOutlined />, label: 'Bulk Jobs' },
  { key: 'notifications', icon: <BellOutlined />, label: 'Notifications' },
  { key: 'settings', icon: <SettingOutlined />, label: 'Settings' },
];

export function AppSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedKey = location.pathname.split('/')[1] || 'dashboard';

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems}
      onClick={(info) => navigate(`/${info.key}`)}
      style={{ height: '100%', borderRight: 0, paddingTop: 8 }}
    />
  );
}